import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@material-ui/core';
import { find } from 'lodash';

function UploadedDataDialog({
  isModalOpen,
  toggleModal,
  dataToEdit,
  rowIndexToUpdate,
  editRowData,
}) {
  const [rowData, updateRowData] = useState(dataToEdit);

  const updateData = (name, value) => {
    updateRowData({
      ...rowData,
      [name]: value,
    });
  };
  return (
    <Dialog open={isModalOpen}>
      <DialogTitle>Edit uploaded data</DialogTitle>
      <DialogContent>
        <Grid container style={{ flexGrow: 1 }} justify="center">
          {Object.keys(rowData).map(key => (
            <TextField
              id={key}
              label={key}
              type={
                key === 'HCP Name' || key === 'HCP Number' ? 'text' : 'number'
              }
              variant="outlined"
              fullWidth
              style={{ marginBottom: '16px' }}
              value={rowData[key]}
              onChange={e => updateData(key, e.target.value)}
              autoFocus
              required
              error={!rowData[key]}
            />
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={find(Object.keys(rowData), key => !rowData[key])}
          variant="outlined"
          color="primary"
          onClick={() => editRowData(rowIndexToUpdate, rowData)}
        >
          Update
        </Button>
        <Button
          variant="outlined"
          onClick={() => toggleModal(false)}
          color="secondary"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UploadedDataDialog;



// WEBPACK FOOTER //
// ./src/UploadedDataDialog.js